import styles from './SpyLaunchSettingsForm.module.css'
import { ModeSwitch } from './presentations/ModeSwitch'
import { Mode } from './presentations/ModeSwitch/ModeSwitch'
import { useState } from 'react'
import { FlexibleForm } from './presentations/FlexibleForm'
import { DatesForm } from './presentations/DatesForm'
import { DateTime } from 'luxon'

interface SpyLaunchSettingsFormProps{
    value: any
    isLoading?: boolean
    onSubmit: (value: any, event: any) => void
    onRepaint?: (event: any) => void
    ref?: any
}

export const SpyLaunchSettingsForm = (props: SpyLaunchSettingsFormProps) => {
    const {
        value,
        onSubmit,
        onRepaint,
        ref
    } = props

    onRepaint?.(undefined)
    const [mode, setMode] = useState<Mode>(value?.mode || 'sliding')
    const [flexibleFormValue, setFlexibleFormValue] = useState<any>({
        daysAhead: value?.params?.daysAhead || 3
    })

    const [datesFormValue, setDatesFormValue] = useState<any>(
        {
            periods: value?.params?.periods || [
                {
                    startDate: DateTime.now(),
                    endDate: DateTime.now().plus({days: 7})
                }
            ]
        }
    )

    const handleModeSwitchValueChange = (event: Mode) => {
        setMode(event)
    }

    const handleFlexibleFormSubmit = (value: any, event: any) => {
        onSubmit?.(
            {
                params: {
                    ...value
                },
                mode: 'sliding'
            },
            event
        )
    }

    const handleDatesFormSubmit = (value: any, event: any) => {
        onSubmit?.(
            {
                params: {
                    ...value
                },
                mode: 'custom'
            },
            event
        )
    }

    const renderForm = (): JSX.Element=> {
        if (mode === 'custom'){
            return (
                <DatesForm 
                    value={value?.params}
                    onSubmit={handleDatesFormSubmit}
                />
            )
        }

        return (
            <FlexibleForm 
                value={value?.params}
                onSubmit={handleFlexibleFormSubmit}
            />
        )
    }

    return (
        <div ref={ref}>
            <div className={styles.SpyLaunchSettingsForm__ModeSwitchContainer}>
                <ModeSwitch 
                    value={mode}
                    onValueChange={handleModeSwitchValueChange}
                />
            </div>
            <div className={styles.SpyLaunchSettingsForm__FormContainer}>
                {
                    renderForm()
                }
            </div>

        </div>
    )
}